const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/MedicationTag/MedicationTag.tsx';
import { css } from '@emotion/css';
import { useIntl } from 'react-intl';
import textMap from './translations';
import { StatusTag } from '../StatusTag/StatusTag';
import { useTheme } from '@mui/material';
import { ReactNode, useMemo } from 'react';

import { getCategories } from '@cistec/common_web/services/orderAndEventsSetupManager';

interface Props {
    ownMedication: boolean;
    mediReserve?: boolean;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            root: css`
                display: flex;
            `,
        }),
        [theme]
    );
}

export const MedicationTag = (props: Props) => {
    const { formatMessage } = useIntl();
    const classes = useCSSClasses();
    const { ownMedication, mediReserve } = props;
    const tags: ReactNode[] = [];

    if (ownMedication) {
        tags.push(<StatusTag caption={formatMessage(textMap.ownMedication)} importance={'warn'} />);
    }
    if (mediReserve) {
        tags.push(<StatusTag caption={getCategories().getIn(['medi-reserve', 'text'])} importance={'warn'} />);
    }
    return tags.length ? <div className={classes.root}>{tags}</div> : null;
};
